import { render, staticRenderFns } from "./LevelsView.vue?vue&type=template&id=0253e458&scoped=true&"
import script from "./LevelsView.vue?vue&type=script&lang=js&"
export * from "./LevelsView.vue?vue&type=script&lang=js&"
import style0 from "./LevelsView.vue?vue&type=style&index=0&id=0253e458&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0253e458",
  null
  
)

export default component.exports